var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-user-avatar"},[(_vm.image)?_c('div',{staticClass:"app-user-avatar__image"},[_c('img',{attrs:{"src":_vm.image}})]):_vm._e(),(!_vm.image)?_c('div',{staticClass:"app-user-avatar__initials"},[_vm._v(_vm._s(_vm.initials))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }